<template>
  <div id="page-user-list">
    <div class="vx-row" id="page-user-view">
      <div class="vx-col lg:w-4/4 w-full">
        <vs-button @click="processAllRecord();" class="mb-8" :disabled="processingRecord">
          <span v-if="processingRecord">
            <i class="feather icon-loader spin-icon mr-2"></i>Processing...
          </span>
          <span v-else>Process All</span>
        </vs-button>
        <vx-card title="Pending Process" class="mb-base">
          <!-- Indicateur de chargement initial -->
          <div v-if="loadingPending" class="text-center my-4">
            <vs-progress :indeterminate="true" color="primary"></vs-progress>
            <p class="mt-2">Loading pending invoices...</p>
            <p class="mt-1 text-sm" style="color: #666;">
              <i class="feather icon-clock"></i>
              Estimated time remaining: <strong>{{ formatRemainingTime(loadingTimePending, 10) }}</strong>
            </p>
          </div>
          <!-- Indicateur de traitement -->
          <div v-else-if="processingRecord" class="text-center my-4">
            <vs-progress :indeterminate="true" color="warning"></vs-progress>
            <p class="mt-2">Processing invoices... please wait</p>
            <p class="mt-1 text-sm" style="color: #666;">
              <i class="feather icon-loader"></i>
              {{ processingCurrent }} / {{ processingTotal }}
            </p>
          </div>
          <vs-table v-else :data="operationsDataNotProcessed" class="table-dark-inverted mb-base" max-items="10">
            <template slot="thead">
              <vs-th>Date</vs-th>
              <vs-th>CUI Sender</vs-th>
              <vs-th>Sender</vs-th>
              <vs-th>Amount</vs-th>
              <vs-th>SPV ID Incarcare</vs-th>
              <vs-th>SPV ID Solicitare</vs-th>
              <vs-th>Status</vs-th>
              <vs-th>Action</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>{{ formatDateSPV(tr.data_creare) }}</vs-td>
                <vs-td>{{ getCui(tr.detalii) }}</vs-td>
                <vs-td>{{ tr.provider || '...' }}</vs-td>
                <vs-td>{{ tr.total_amount_with_tva ? parseFloat(tr.total_amount_with_tva).toFixed(2) + ' ' + (tr.currency || '') : '...' }}</vs-td>
                <vs-td>{{ tr.id_solicitare }}</vs-td>
                <vs-td>{{ tr.id }}</vs-td>
                <vs-td><vs-chip color="danger">
                    <span>Not Processed</span>
                  </vs-chip>
                </vs-td>
                <vs-td>
                  <feather-icon v-if="tr.detalii && tr.detalii.startsWith('Factura cu')" icon="PlayIcon"
                    svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="ProcessRecord(tr)" />
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import moduleBankList from '@/store/bank/moduleDataList.js'

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import moment from 'moment'

export default {
  components: {
    AgGridVue,
    vSelect,
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions
  },
  data() {
    return {
      efacturaList: [],
      currentValue: null,
      searchQuery: '',
      loadingPending: false,
      loadingTimePending: 0,
      loadingIntervalPending: null,
      processingRecord: false,
      processingCurrent: 0,
      processingTotal: 0,
      // AgGrid
      gridApi: null,
      gridOptions: {},
      suppressSizeToFit: true,
      defaultColDef: {
        sortable: false,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'DATE',
          valueGetter: (params) => this.formatDateSPV(params.data.data_creare),
          filter: true,
          width: 150,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'INVOICE NO',
          valueGetter: function (params) {
            if (params.data.invoice_no) {
              return params.data.invoice_no
            }
            return 'N/A'
          },
          cellRendererFramework: 'CellRendererStatus',
          filter: true,
          width: 190,
        },
        {
          headerName: 'CUI SENDER',
          valueGetter: function (params) {
            if (params.data.detalii) {
              let cifBeneficiarRegex = /cif_emitent=(\d+)/;
              let match = params.data.detalii.match(cifBeneficiarRegex);
              let cifBeneficiar = match ? match[1] : null;
              if (cifBeneficiar) return cifBeneficiar
            }
            if (params.data.cif) return params.data.cif.replace("RO", "")
            //return params.data.cif.replace("RO","")
          },
          filter: true,
          width: 170
        },
        {
          headerName: 'SENDER',
          valueGetter: function (params) {
            if (params.data.provider) {
              return params.data.provider
            }
            return 'N/A'
          },
          cellRendererFramework: 'CellRendererStatus',
          filter: true,
          width: 380,
        },
        {
          headerName: 'AMOUNT exVAT',
          valueGetter: function (params) {
            if (params.data.amount_htva) {
              return parseFloat(params.data.amount_htva).toFixed(2) + " " + params.data.currency
            }
            return 'N/A'
          },
          cellRendererFramework: 'CellRendererStatus',
          filter: true,
          width: 180,
        },
        {
          headerName: 'AMOUNT iVAT',
          valueGetter: function (params) {
            if (params.data.total_amount_with_tva) {
              return parseFloat(params.data.total_amount_with_tva).toFixed(2) + " " + params.data.currency
            }
            return 'N/A'
          },
          cellRendererFramework: 'CellRendererStatus',
          filter: true,
          width: 180,
        },
        {
          headerName: 'IS PAID?',
          valueGetter: function (params) {
            if (params.data.paymentmeans && (params.data.paymentmeans == 1 || params.data.paymentmeans == 10)) {
              return 'Paid (Cash/POS)'
            }
            else if (params.data.cif && params.data.cif.replace("RO", "") === '2816464') return 'Paid (Cash/POS)'
            else if (params.data.cif && params.data.cif.replace("RO", "") === '2864518') return 'Paid (Cash/POS)'
            else if (params.data.cif && params.data.cif.replace("RO", "") === '18107744') return 'Paid (Cash/POS)'
            else if (params.data.count_transactions) return 'Transaction YD' + params.data.idoperation + ' (' + parseFloat(params.data.count_transactions).toFixed(2) + ' ' + params.data.currency + ')'
            else if (params.data.ispaid) return 'Paid'
            return 'Not Paid'
          },
          filter: true,
          width: 280,
          cellRendererFramework: 'CellRendererStatus'
        },
        {
          headerName: 'ACTIONS',
          field: 'transactions',
          width: 120,
          cellRendererFramework: 'CellRendererActions'
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions
      }
    }
  },
  computed: {
    operationsDataNotProcessed() {
      return this.$store.state.BankList.downloadinvoices.filter(invoice =>
        invoice.detalii && invoice.detalii.startsWith('Factura cu')
      );
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    removeFilterNotPaid() {
      this.searchQuery = ''
      this.updateSearchQuery('')
    },
    filterNotPaid() {
      this.searchQuery = 'Not Paid'
      this.updateSearchQuery('Not Paid')
    },
    async processAllRecord() {
      if (!moduleBankList.isRegistered) {
        this.$store.registerModule('BankList', moduleBankList)
        moduleBankList.isRegistered = true
      }

      this.processingRecord = true;
      this.processingCurrent = 0;
      this.processingTotal = this.operationsDataNotProcessed.length;

      let cifBeneficiarRegex = /cif_emitent=(\d+)/;

      try {
        for (const data of [...this.operationsDataNotProcessed]) {
          this.processingCurrent++;
          let match = data.detalii.match(cifBeneficiarRegex);
          let cifBeneficiar = match ? match[1] : null;
          let item = {
            id: data.id,
            id_solicitare: data.id_solicitare,
            cui: cifBeneficiar,
            dt: this.formatDateSPVcall(data.data_creare)
          };
          await this.$store.dispatch('BankList/InsertEFactura', { item });
        }
      } finally {
        this.processingRecord = false;
        this.processingCurrent = 0;
        this.processingTotal = 0;
      }
    },
    async processAllRecordOld() {
      if (!moduleBankList.isRegistered) {
        this.$store.registerModule('BankList', moduleBankList)
        moduleBankList.isRegistered = true
      }
      let cifBeneficiarRegex = /cif_emitent=(\d+)/;

      await this.operationsDataNotProcessed.forEach(data => {
        this.$vs.notify({
          title: "Processing eFactura (old algo)",
          text: data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "bottom-center",
          time: 2000,
        });
        let match = data.detalii.match(cifBeneficiarRegex);
        let cifBeneficiar = match ? match[1] : null;
        let item = {
          id: data.id,
          id_solicitare: data.id_solicitare,
          cui: cifBeneficiar,
          dt: this.formatDateSPVcall(data.data_creare)
        }
        this.$store.dispatch('BankList/InsertEFacturaOld', { item })
      });
    },
    async ProcessRecord(data) {
      if (!moduleBankList.isRegistered) {
        this.$store.registerModule('BankList', moduleBankList)
        moduleBankList.isRegistered = true
      }

      this.processingRecord = true;
      this.processingCurrent = 1;
      this.processingTotal = 1;

      try {
        let cifBeneficiarRegex = /cif_emitent=(\d+)/;
        let match = data.detalii.match(cifBeneficiarRegex);
        let cifBeneficiar = match ? match[1] : null;

        let item = {
          id: data.id,
          id_solicitare: data.id_solicitare,
          cui: cifBeneficiar,
          dt: this.formatDateSPVcall(data.data_creare)
        }
        await this.$store.dispatch('BankList/InsertEFactura', { item })
      } finally {
        this.processingRecord = false;
        this.processingCurrent = 0;
        this.processingTotal = 0;
      }
    },

    getCui(value) {
      if (value) {
        let cifBeneficiarRegex = /cif_emitent=(\d+)/;
        let match = value.match(cifBeneficiarRegex);
        let cifBeneficiar = match ? match[1] : null;
        if (cifBeneficiar) return cifBeneficiar
      }
    },
    formatDateSPVcall(dateStr) {
      if (dateStr && dateStr.length === 12) {
        const year = dateStr.substring(0, 4);
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);
        const hour = dateStr.substring(8, 10);
        const minute = dateStr.substring(10, 12);
        const date = moment(`${year}-${month}-${day} ${hour}:${minute}`, 'YYYY-MM-DD HH:mm');
        return date.format('YYYY-MM-DD');
      } else {
        return 'Format de date invalide';
      }
    },
    formatDateSPV(dateStr) {
      if (dateStr && dateStr.length === 12) {
        const year = dateStr.substring(0, 4);
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);
        const hour = dateStr.substring(8, 10);
        const minute = dateStr.substring(10, 12);
        const date = moment(`${year}-${month}-${day} ${hour}:${minute}`, 'YYYY-MM-DD HH:mm');
        return date.format('DD/MM/YYYY');
      } else {
        return 'Format de date invalide';
      }
    },
    format_dates(value, withhour) {
      if (value) {
        if (withhour)
          return moment(String(value)).format("DD MMM YYYY HH:mm:ss");
        else return moment(String(value)).format("DD MMM YYYY");
      }
    },
    formatDate(dateString) {
      let date = new Date(dateString);
      let day = date.getDate().toString().padStart(2, '0');
      let month = (date.getMonth() + 1).toString().padStart(2, '0'); // Les mois sont indexés à partir de 0
      let year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    formatRemainingTime(elapsedSeconds, estimatedTotalSeconds) {
      const remaining = Math.max(0, estimatedTotalSeconds - elapsedSeconds);
      if (remaining < 1) {
        return 'Almost done...';
      } else if (remaining < 60) {
        return `${remaining.toFixed(0)}s`;
      } else {
        const mins = Math.floor(remaining / 60);
        const secs = Math.floor(remaining % 60);
        return `${mins}m ${secs}s`;
      }
    }
  },
  beforeDestroy() {
    // Nettoyer l'interval de chronomètre
    if (this.loadingIntervalPending) {
      clearInterval(this.loadingIntervalPending);
      this.loadingIntervalPending = null;
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api

  },
  created() {

    if (!moduleBankList.isRegistered) {
      this.$store.registerModule('BankList', moduleBankList)
      moduleBankList.isRegistered = true
    }
    if (localStorage.getItem("login-roles").toLowerCase().includes("user")) {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the this page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/dashboard/analytics" });
    }

    try {
      // Démarrer le chronomètre
      this.loadingTimePending = 0;
      this.loadingPending = true;
      this.loadingIntervalPending = setInterval(() => {
        this.loadingTimePending += 0.1;
      }, 100);

      this.$store.dispatch('BankList/downloadInvoice')
        .then(response => {
          this.efacturaList = response.data
          this.$vs.loading.close()
        })
        .catch(err => {
          this.$vs.notify({
            title: "Access Denied",
            text: "Please create a SPV TOKEN",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "bottom-center",
            time: 8000,
          });
          console.error(err)

          this.$router.push({ path: "/settings/menu" });

        })
        .finally(() => {
          // Arrêter le chronomètre
          this.loadingPending = false;
          if (this.loadingIntervalPending) {
            clearInterval(this.loadingIntervalPending);
            this.loadingIntervalPending = null;
          }
        })

    } catch (error) {
      console.error("Error in component created hook:", error);
      // Arrêter le chronomètre en cas d'erreur
      this.loadingPending = false;
      if (this.loadingIntervalPending) {
        clearInterval(this.loadingIntervalPending);
        this.loadingIntervalPending = null;
      }
    }
  },
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}


.context-menu {
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.context-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.context-menu ul li {
  padding: 10px;
  cursor: pointer;
}

.context-menu ul li:hover {
  background-color: #f0f0f0;
}

.spin-icon {
  display: inline-block;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
</style>
